import { configValue } from '#/config/appConfigUtils';

export function getStaticImageSrc<TFilePath extends string>(
  filePath: TFilePath,
): `$staticImgPath/${TFilePath}` {
  const imagesPath = configValue('idealist', 'staticImgPath');
  return `${imagesPath}${filePath}` as `$staticImgPath/${TFilePath}`;
}
